import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import TaskDetailContainer from '../../../../containers/projects/TaskDetailContainer.jsx';

const TaskDetail = ({ changeImpactId, projectId, taskId, slug }) => (
  <>
    <Helmet>
      <title>Task | ChangeSync</title>
    </Helmet>
    <TaskDetailContainer
      projectId={projectId}
      changeImpactId={changeImpactId}
      taskId={taskId}
      slug={slug}
    />
  </>
);

TaskDetail.getInitialProps = ({ query }) => ({
  changeImpactId: Number(query.changeImpactId),
  projectId: Number(query.projectId),
  taskId: Number(query.taskId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(TaskDetail));
